import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
// import { storeTypeList } from "utils/data";
import SoftInput from "components/SoftInput";
import { useTranslation } from "react-i18next";
import { Switch } from "@mui/material";

function UserInfo({ formData, onChange, validateFormCallback, formSubmitted }) {
  const { t } = useTranslation();

  const [formFields, setFormFields] = useState({
    // store_type: formData?.store_type || "",
    firstname: formData?.firstname || "",
    lastname: formData?.lastname || "",
    phone: formData?.phone || "",
    password: formData?.password || "",
    password2: formData?.password2 || "",
    old_user: formData?.old_user || false,
  });

  const [errors, setErrors] = useState({});

  const validateForm = (submit = false) => {
    const newErrors = {};

    if (!/^\d{8}$/.test(formFields.phone.trim())) {
      newErrors.phone = `${t(
        "Le numéro de téléphone doit contenir 8 chiffres"
      )}`;
    }
    if (formFields.password !== formFields.password2) {
      newErrors.password2 = `${t("Les mots de passe ne correspondent pas")}`;
    }
    setErrors(newErrors);
    validateFormCallback(Object.keys(newErrors).length === 0);
  };

  useEffect(() => {
    onChange(formFields);
    // eslint-disable-next-line
  }, [formFields]);

  useEffect(() => {
    if (formSubmitted) {
      validateForm(true);
    }
    // eslint-disable-next-line
  }, [formSubmitted]);

  const handleInputChange = (fieldName, value) => {
    if (
      ["firstname", "lastname"].includes(fieldName) &&
      /^\d+$/.test(value.trim())
    ) {
      return;
    }
    setFormFields((prevFields) => ({ ...prevFields, [fieldName]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: null }));
  };

  return (
    <SoftBox>
      <SoftBox lineHeight={0}>
        <SoftTypography variant="h5" fontWeight="bold">
          {t("Informations de client")}
        </SoftTypography>
      </SoftBox>
      <SoftBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={5}>
            <SoftTypography variant="caption" fontWeight="bold">
              {t("Prénom")}
            </SoftTypography>
            <SoftInput
              type="text"
              value={formFields.firstname || formData.firstname}
              onChange={(e) => handleInputChange("firstname", e.target.value)}
              placeholder={t("Entrez votre prénom")}
              error={formSubmitted && errors.firstname}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <SoftTypography variant="caption" fontWeight="bold">
              {t("Nom de famille")}{" "}
            </SoftTypography>
            <SoftInput
              type="text"
              value={formFields.lastname || formData.lastname}
              onChange={(e) => handleInputChange("lastname", e.target.value)}
              placeholder={t("Entrez votre nom de famille")}
              error={formSubmitted && errors.lastname}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" height="100%">
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
                textTransform="capitalize"
                mb={1}
              >
                {t("Ancien Client")}
              </SoftTypography>
              <Switch
                checked={formFields.old_user}
                onChange={(e) => handleInputChange("old_user", e.target.checked)}
              />
            </SoftBox>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="caption" fontWeight="bold">
              {t("Numéro de téléphone")}{" "}
            </SoftTypography>
            <SoftInput
              type="text"
              value={formFields.phone || formData.phone}
              onChange={(e) => handleInputChange("phone", e.target.value)}
              placeholder={t("Entrez votre numéro de téléphone")}
              error={formSubmitted && errors.phone}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="caption" fontWeight="bold">
              {t("Mot de passe")}{" "}
            </SoftTypography>
            <SoftInput
              type="password"
              value={formFields.password}
              onChange={(e) => handleInputChange("password", e.target.value)}
              placeholder={t("Entrez votre mot de passe")}
              error={formSubmitted && errors.password}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <SoftTypography variant="caption" fontWeight="bold">
              {t("Confirmer le mot de passe")}
            </SoftTypography>
            <SoftInput
              type="password"
              value={formFields.password2}
              onChange={(e) => handleInputChange("password2", e.target.value)}
              placeholder={t("Confirmez votre mot de passe")}
              error={formSubmitted && errors.password2}
            />
          </Grid>
        </Grid>
      </SoftBox>
    </SoftBox>
  );
}

export default UserInfo;
